<template>
	<div class="center-page-minus" :class="{ '--kiosk': isKiosk }">
		<div v-if="!isKiosk && $store.state.store.openInfo">
			<div style="width: 100%; display: inline-block; margin-top: 5%">
				<div
					@click="openShopInfo"
					style="width: 95%; text-align: right; color: #1976d2"
				>
					門市資訊
				</div>
			</div>

			<div
				class="shopAnnouncement"
				v-if="
					this.$store.state.store.openInfo.shopAnnouncement &&
					this.$store.state.store.openInfo.shopAnnouncement.length > 0
				"
			>
				<div
					class="shopAnnouncementBackground"
					style="
						min-height: 100px;
						background: #f3f3f3;
						width: 90%;
						margin: 5%;
						padding: 5%;
						border-radius: 10px;
					"
				>
					<div
						class="shopAnnouncementContent"
						style="
							padding-top: 0;
							width: 100%;
							display: inline-block;
							word-wrap: break-word;
							line-height: 20px;
						"
						v-html="toHtml(this.$store.state.store.openInfo.shopAnnouncement)"
					></div>
				</div>
			</div>
			<div v-else style="margin-top: 5%"></div>
			<!-- TAG: 取餐方式的選擇器 -->
			<div
				class="pickUp-method-wrapper"
				@click="handlePickupMethodClick"
				v-if="pickUpMethodWrapperAvailable"
			>
				<div
					class="pickUp-method-displayer"
					:class="{ '--method-exist': pickUpMethodExist }"
				>
					{{ pickUpDisplayText }}
					<div class="icon-wrapper" v-if="pickUpMethodExist">
						<img
							class="edit-icon"
							src="@/assets/edit.svg"
							alt="edit pickup method"
						/>
					</div>
				</div>
			</div>

			<ByDialog
				:class="{ 'detail-dialog--kiosk': isKiosk }"
				width="90%"
				v-model="isShopInfo"
				title="門市資訊"
				@cancel="closeShopInfo"
				@confirm="closeShopInfo"
				:noCancelButton="true"
			>
				<div
					style="
						background: #f3f3f3;
						min-height: 50px;
						margin-top: 5px;
						display: flex;
						align-items: center;
					"
				>
					<div style="display: inline-block; margin-left: 2%; width: 30%">
						營業日
					</div>
					<div
						style="
							display: inline-block;
							width: 70%;
							margin-right: 2%;
							word-wrap: break-word;
						"
					>
						<div v-for="(dayRows, dayIndex) in businessHours" :key="dayIndex">
							<div
								v-for="(row, rowIndex) in dayRows"
								:key="`${dayIndex}-${rowIndex}`"
								style="display: flex"
							>
								<div :style="{ width: '50%', textAlign: 'right' }">
									<span>{{ row.label }}</span>
								</div>
								<div :style="{ width: '50%', textAlign: 'right' }">
									<span>{{ row.time }}</span>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div
					style="
						background: #f3f3f3;
						min-height: 50px;
						margin-top: 5px;
						display: flex;
						align-items: center;
					"
				>
					<div style="display: inline-block; margin-left: 2%; width: 30%">
						本月休息日
					</div>
					<div
						style="
							display: inline-block;
							width: 70%;
							margin-right: 2%;
							word-wrap: break-word;
						"
					>
						<div style="text-align: right; white-space: pre-line">
							{{ restDays }}
						</div>
					</div>
				</div>
				<div
					v-if="
						this.$store.state.store.openInfo.shopPhone &&
						this.$store.state.store.openInfo.shopPhone.length > 0
					"
					style="
						background: #f3f3f3;
						min-height: 50px;
						margin-top: 5px;
						display: flex;
						align-items: center;
					"
				>
					<div style="display: inline-block; margin-left: 2%; width: 30%">
						連絡電話
					</div>
					<div
						style="
							display: inline-block;
							width: 70%;
							margin-right: 2%;
							word-wrap: break-word;
						"
					>
						<div style="text-align: right">
							{{ this.$store.state.store.openInfo.shopPhone }}
						</div>
					</div>
				</div>
				<div
					v-if="
						this.$store.state.store.openInfo.shopAddress &&
						this.$store.state.store.openInfo.shopAddress.length > 0
					"
					style="
						background: #f3f3f3;
						min-height: 50px;
						margin-top: 5px;
						display: flex;
						align-items: center;
					"
				>
					<div style="display: inline-block; margin-left: 2%; width: 30%">
						地址
					</div>
					<div
						style="
							display: inline-block;
							width: 70%;
							margin-right: 2%;
							word-wrap: break-word;
						"
					>
						<div style="text-align: right">
							{{ this.$store.state.store.openInfo.shopAddress }}
						</div>
					</div>
				</div>
			</ByDialog>
		</div>

		<div class="product-container">
			<div class="items" :style="{ marginRight: canBuy ? '350px' : 0 }">
				<ByPickerBar
					class="picker-bar"
					:class="{ '--kiosk': isKiosk }"
					:items="category"
					v-model="currentCategory"
					@onChange="onTabChange"
					ref="categoryTabs"
				/>
				<ByInput
					type="search"
					class="search"
					:class="{ '--kiosk': isKiosk }"
					placeholder="搜尋餐點"
					v-model="searchText"
					@input="searchTextInput"
					@search="search"
					ref="searchInputRef"
				/>
				<!--不是前台 且 店家不開放 -->
				<div
					class="not-open"
					v-if="
						$store.state.store.openInfo &&
						!firstLoad &&
						!isKiosk &&
						!isMobileOrder
					"
					:style="{ marginTop: isKiosk ? '16px' : 0 }"
				>
					很抱歉，目前店家未開啟手機點餐功能，若有點餐需求請直接與店家聯繫。
				</div>
				<!--不是前台 且 (非店家營業時間、店家不開放預約 或 無可用取餐方式) 有開啟手機點餐-->
				<div
					class="not-open"
					v-if="
						$store.state.store.openInfo &&
						!firstLoad &&
						!isKiosk &&
						((!(isOpen || isBooking) && isMobileOrder) ||
							(!hasAvailablePickupMethods && isMobileOrder))
					"
					:style="{ marginTop: isKiosk ? '16px' : 0 }"
				>
					很抱歉，目前非營業時間，請於營業時間內進行點餐。
				</div>
				<div class="left category-title">
					{{ categoryTitleText }}
				</div>
				<!-- 菜單載入反饋（脫離 globalLoading，避免被 runStages 的 hide 吞掉） -->
				<ByLoadingFeedback
					:value="menuFeedbackVisible"
					:status="menuFeedbackStatus"
					message="載入菜單中..."
					:error-text="menuLoadError || '載入菜單失敗'"
					:fullscreen="true"
					:show-result="true"
					:show-refresh-on-error="true"
					:result-duration="0"
				/>
				<div class="product-grid">
					<div
						:class="['product-item', item.remark ? '' : 'no-content']"
						v-for="item in displayRows"
						:key="item.itemId"
						@click="goDetail(item)"
					>
						<div class="product-info">
							<div class="product-name">
								{{ item.itemName }}
								<div class="product-status">
									<ByIcon
										icon="king"
										size="24"
										v-if="item.tag?.includes('HOT')"
									/>
									<ByIcon
										icon="new"
										size="36"
										v-if="item.tag?.includes('NEW')"
									/>
									<ByIcon
										icon="spicy"
										type="png"
										size="24"
										v-if="item.tag?.includes('SPICY')"
									/>
									<ByIcon
										icon="vegetarian"
										type="png"
										size="24"
										v-if="item.tag?.includes('VEGETARIAN')"
									/>
									<div
										class="product-status-discount-tag"
										v-if="item.automaticDiscountId"
									>
										特價中
									</div>
								</div>
							</div>
							<div class="product-content" v-if="item.description">
								{{ item.description }}
							</div>

							<div class="product-price-area">
								<div
									:class="
										item.discountPrice
											? 'product-price-area-original-price'
											: 'product-price-area-price'
									"
								>
									${{ $stepPrice(item.price) }}
								</div>

								<!--折扣後金額-->
								<div
									class="product-price-area-discount-price"
									v-if="item.discountPrice"
								>
									${{ $stepPrice(discountedItemPrice(item)) }}
								</div>
							</div>
						</div>
						<div class="product-img" v-show="item.itemLogoUrl">
							<img
								:src="item.itemLogoUrl ? `${httpUrl}${item.itemLogoUrl}` : null"
								@error="handleItemPicLoadError(item)"
								alt="餐點圖片"
							/>
							<div v-if="!item.availableForSale" class="sold-out-text">
								售完
							</div>
						</div>

						<div class="product-plus" v-show="!item.itemLogoUrl && canBuy">
							<ByIcon v-if="item.availableForSale" icon="plus" />
							<div v-else class="sold-out-text">售完</div>
						</div>

						<!--售完-->
						<div class="sold-out-overlay" v-if="!item.availableForSale" />
					</div>
				</div>
				<ByFooter />
			</div>

			<!--前台點餐結帳面板-->
			<!--Cart Grid 與 手機點餐共用-->
			<div class="cart-panel" v-if="isKiosk && canBuy">
				<div class="cart-panel_title">我的購物車</div>
				<ByCartGrid
					class="cart-panel_grid"
					no-count
					:editFun="showDetailDialog"
					v-if="cartLength"
				/>

				<div class="cart-panel_welcome" v-else>歡迎開始點餐</div>

				<!--前台自動折扣-->
				<div class="cart-panel-order-discount">
					<div
						class="cart-panel-order-discount-use"
						v-if="useOrderAutomaticDiscount"
					>
						<span>「{{ useOrderAutomaticDiscount.name }}」</span>
						<span>-${{ orderAutomaticDiscountPrice }}</span>
					</div>
					<div
						class="cart-panel-order-discount-next"
						v-if="nextOrderAutomaticDiscount"
					>
						*差${{
							nextOrderAutomaticDiscount.minimumSpendingAmount - cartTotal
						}}元 即可達到 「{{ nextOrderAutomaticDiscount.name }}」
					</div>
				</div>

				<ByInput
					class="cart-panel_remark"
					placeholder="新增給店家的備註"
					type="textarea"
					v-model="$store.state.kioskOrderRemark"
				/>
				<div class="cart-panel_btns">
					<ByButton
						class="btn"
						stl="main2"
						@click="onShowClearCartConfirm"
						:disabled="!cartLength"
						>清空
					</ByButton>
					<ByButton
						class="btn send"
						stl="main1"
						@click="onToOrder"
						:disabled="!cartLength"
						:loading="isToOrderLoading"
					>
						<div class="btn_num" v-if="cartLength">[{{ productLength }}]</div>
						<div class="btn_text">結帳</div>
						<div class="btn_total" v-if="cartLength">${{ payableTotal }}</div>
					</ByButton>
				</div>
			</div>
		</div>
		<ByTopBtn :bottom="productLength ? '55px' : '15px'" v-if="!isKiosk" />
		<AddCart v-if="!isKiosk && canBuy" />
		<ByDialog
			:class="{ 'detail-dialog--kiosk': isKiosk }"
			width="465px"
			v-model="isDetailDialog"
			no-title
		>
			<Detail
				:detail-id="detailId"
				:isPropEdit="isEditDetail"
				ref="detailRef"
				@invalid-item="isDetailDialog = false"
			/>
			<template slot="dialog-footer">
				<div class="kiosk-dialog-footer-wrap" v-if="canBuy">
					<ByButton stl="main1" @click="onEditCart" v-if="isEditDetail"
						>更新購物車
					</ByButton>
					<ByButton stl="main1" @click="onAddCart" v-else>加入購物車</ByButton>
				</div>
				<div v-else />
			</template>
		</ByDialog>
		<ByCompareCartConfirm ref="compareCartConfirmRef" />
		<ByClearCartConfirm v-model="isShowClearCartConfirm" />
		<!-- TAG: 取餐方式的選擇跳窗 -->
		<PickupMethodDialog
			v-model="isPickupMethodShowing"
			width="465px"
			title="選擇取餐方式和時間"
			@cancel="handleCancelPickupMethod"
			@confirm="handlePickUpConfirm"
		/>
	</div>
</template>

<script>
import AddCart from '@/views/buy/AddCart'
import Detail from '@/views/buy/Detail/Detail'
import ByDialog from '../../components/Dialog'
import ByIcon from '../../components/Icon.vue'
import PickupMethodDialog from '@/components/PickupMethodDialog.vue'
import { ceilAwayFromZero, getOrderPayableTotal } from '@/utils/order'
import {
	captureFullMenuRequest,
	isFullMenuCacheFresh,
	isFullMenuSnapshotApplied,
} from '@/utils/menuCache'

// 重連補刷菜單的節流窗口：網路抖動時重連可每 1.5~3 秒一次（與取餐頁同款合併節流）
const RECONNECT_SYNC_INTERVAL = 10000

export default {
	components: { ByIcon, ByDialog, Detail, AddCart, PickupMethodDialog },
	data() {
		return {
			rows: [],
			category: [{ id: '0', name: '全部' }],
			currentCategory: '0',
			source: [],
			searchText: '',
			// 已送出的搜尋關鍵字：背景重載（推播 / 重連補刷）一律用此值，
			// 不可用 searchText（輸入框即時值，打字到一半就會被帶進請求）
			submittedKeyword: '',
			isAll: true,
			isDetailDialog: false,
			detailId: 0,
			isToOrderLoading: false,
			isShowClearCartConfirm: false,
			isEditDetail: false,
			firstLoad: true,
			isShopInfo: false,
			week: {
				1: '週一',
				2: '週二',
				3: '週三',
				4: '週四',
				5: '週五',
				6: '週六',
				7: '週日',
			},
			// 菜單資料已經就緒
			menusReady: false,
			isPickupMethodShowing: false,
			// 菜單載入版本號，用於防止競態
			menuLoadVersion: 0,
			// created 判斷快取命中、mounted 才重建畫面（$refs 需已建立）
			shouldRestoreFromCache: false,
			// 菜單正在載入中（脫離 globalLoading，避免被 runStages 的 hide 吞掉）
			isMenuLoading: false,
			// 菜單載入錯誤訊息
			menuLoadError: null,
			// 上次因重連而補刷菜單的時間
			lastReconnectSyncAt: 0,
			reconnectSyncTimer: null,
		}
	},
	computed: {
		pickUpDisplayText() {
			return this.$store.getters['user/pickUpDisplayText']
		},
		pickUpMethodExist() {
			return !!this.$store.state.user.pickUpMethod
		},
		hasAvailablePickupMethods() {
			// 檢查是否有可用的取餐方式
			const mobilePickupMethod =
				this.$store.state.store?.openInfo?.mobilePickupMethod
			if (!mobilePickupMethod) return false

			const isStoreOpen = this.$store.getters.isOpen
			let availableMethods = Object.entries(mobilePickupMethod)
				.filter(([key, value]) => value.methodSwitch)
				.map(([key]) => key)

			// 非營業時間時過濾掉內用
			if (!isStoreOpen) {
				availableMethods = availableMethods.filter(
					method => method !== 'dineIn',
				)
			}

			return availableMethods.length > 0
		},
		pickUpMethodWrapperAvailable() {
			const storeIsOpen = this.$store.getters.isOpen

			// 檢查是否有可用的取餐方式
			if (!this.hasAvailablePickupMethods) {
				return false
			}

			if (storeIsOpen) {
				return true
			} else if (!storeIsOpen && this.isBookingAvailable) {
				return true
			} else {
				return this.$store.getters.isBooking
			}
		},
		businessHours() {
			const result = []

			const businessHoursList =
				this.$store.state.store.openInfo.businessHoursList

			// Step 1: 按星期排序 & 分組
			businessHoursList.sort((a, b) => a.week - b.week)
			const grouped = {}
			businessHoursList.forEach(e => {
				if (!grouped[e.week]) grouped[e.week] = []
				grouped[e.week].push(this.businessHoursText(e))
			})
			// Step 2: 用 for 合併連續時段相同的星期
			const merged = []
			for (let i = 1; i <= 7; i++) {
				if (!grouped[i]) continue

				const currentTimes = JSON.stringify(grouped[i])
				let start = i
				let end = i

				for (let j = i + 1; j <= 7; j++) {
					if (!grouped[j]) break
					if (JSON.stringify(grouped[j]) === currentTimes) {
						end = j
					} else {
						break
					}
				}

				merged.push({ start, end, times: grouped[i] })
				i = end // 下一輪從 end+1 開始
			}

			// Step 3: 組成最終顯示資料
			merged.forEach(({ start, end, times }) => {
				const label =
					start === end
						? this.week[start]
						: `${this.week[start]}至${this.week[end]}`
				const lines = [{ label, time: times[0] }]

				for (let i = 1; i < times.length; i++) {
					lines.push({ label: '', time: times[i] })
				}

				result.push(lines)
			})

			return result
		},
		restDays() {
			const { restType, restDays, restDates } = this.$store.state.store.openInfo

			if (restType === 'FIXED_REST') {
				return this.formatFixedRest(restDays)
			} else if (restType === 'UNFIXED_REST') {
				return this.formatUnfixedRest(restDates)
			} else if (restType === 'MIXED_REST') {
				return this.formatMixedRest(restDays, restDates)
			} else {
				return '無'
			}
		},
		httpUrl() {
			return window.location.origin
		},
		displayCategory() {
			if (this.currentCategory) {
				return (
					this.category.find(item => item.id === this.currentCategory) &&
					this.category.find(item => item.id === this.currentCategory).name
				)
			}
			return '全部'
		},
		qrCodeHash() {
			return this.$storeManager.qrCodeHash
		},
		storeId() {
			return this.$storeManager.storeId
		},
		cart() {
			const cart = this.$store.getters['user/currCart'](this.qrCodeHash)
			return cart || []
		},
		cartLength() {
			const current = this.cart
			return current ? current.length : 0
		},
		productLength() {
			return this.$store.getters['user/productLength'](this.qrCodeHash)
		},
		// 前台點餐
		isKiosk() {
			return this.$store.getters.isKiosk
		},
		cartTotal() {
			return this.$store.getters['user/cartTotal'](this.qrCodeHash) || 0
		},
		canBuy() {
			return this.$store.getters.canBuy
		},
		isOpen() {
			return this.$store.getters.isOpen
		},
		isBooking() {
			return this.$store.getters.isBooking
		},
		isMobileOrder() {
			return this.$store.getters.isMobileOrder
		},
		// 商品自動折扣
		itemAutomaticDiscountList() {
			return this.$store.state.store.itemAutomaticDiscountList
		},
		// 訂單自動折扣金額(折數換算金額、金額)
		orderAutomaticDiscountPrice() {
			const storeId = this.storeId
			if (!storeId) return 0
			return this.$store.getters['user/orderAutomaticDiscountPriceByStore'](
				storeId,
			)
		},
		payableTotal() {
			return getOrderPayableTotal(
				this.cartTotal,
				this.orderAutomaticDiscountPrice,
			)
		},
		// 套用的訂單自動折扣
		useOrderAutomaticDiscount() {
			const storeId = this.storeId
			if (!storeId) return null
			return this.$store.getters['user/useOrderAutomaticDiscountByStore'](
				storeId,
			)
		},
		// 目標訂單自動折扣
		nextOrderAutomaticDiscount() {
			const storeId = this.storeId
			if (!storeId) return null
			return this.$store.getters['user/nextOrderAutomaticDiscountByStore'](
				storeId,
			)
		},
		// WebSocket 重連序號（每次重連成功遞增）
		reconnectSeq() {
			return this.$store.state.socket.reconnectSeq
		},
		// 菜單被比對結果就地 patch 的次數
		menuPatchSeq() {
			return this.$store.state.store.menuPatchSeq
		},
		// 自動折扣列表已就緒
		automaticDiscountListReady() {
			return this.$store.state.store.automaticDiscountListReady
		},
		// 自動折扣列表&菜單皆已就緒
		isReadyToSetMenuDiscount() {
			return this.automaticDiscountListReady && this.menusReady
		},
		// 菜單載入反饋是否可見：首次載入的錯誤／loading 才顯示；已有菜單時一律不顯示。
		// 此面板是 fullscreen 且錯誤態只能整頁重載，不應讓搜尋或背景補刷失敗蓋掉仍可用的菜單。
		menuFeedbackVisible() {
			if (this.menusReady) return false
			if (this.menuLoadError) return true
			return this.isMenuLoading && !this.$store.state.globalLoading.visible
		},
		// 菜單載入反饋狀態
		menuFeedbackStatus() {
			if (this.menuLoadError) return 'error'
			return 'loading'
		},
		// 過濾後的商品列表
		displayRows() {
			if (this.isKiosk) {
				return this.rows
			}
			return this.rows.filter(item => item.mobileStatus !== false)
		},
		// 分類標題：區分「載入中」與「真正查無結果」
		categoryTitleText() {
			// 菜單尚未就緒（首次載入中或刷新中）→ 不顯示「查無」
			if (this.firstLoad || !this.menusReady) {
				return this.displayCategory || ''
			}
			// 菜單已就緒但無結果 → 才顯示「查無符合餐點」
			return this.displayRows.length ? this.displayCategory : '查無符合餐點'
		},
		isBookingAvailable() {
			return this.$store.getters.isBooking
		},
	},
	created() {
		if (this.storeId) {
			this.currentCategory = sessionStorage.getItem('category') || '0'

			// 推播旗標可能在上一個 Store 實例銷毀後才被設起來（路由切換邊界）：
			// 此時新實例的 watcher 收不到 false→true 轉換，旗標會永遠卡在 true
			// 讓之後每一次推播都失效，故建立時先消耗掉並強制補刷一次
			const hasPendingMenuRefresh = this.$store.state.store.refreshMenu
			if (hasPendingMenuRefresh) {
				this.$store.commit('store/SET_REFRESH_MENU', false)
			}

			// 快取命中只記錄待還原，實際重建與捲動還原留到 mounted：
			// created 期間 $refs 尚未建立，分類 tab 置中與捲動會靜默失效
			this.shouldRestoreFromCache =
				!hasPendingMenuRefresh && this.canUseFullMenuCache()

			if (!this.shouldRestoreFromCache) {
				this.reloadMenu()
			}
		}
	},
	mounted() {
		if (this.shouldRestoreFromCache) {
			this.shouldRestoreFromCache = false
			this.applyMenuList(this.$store.state.store.menus)
			this.$nextTick(() => {
				this.backToLastPagePosition()
			})
		}

		// 檢查是否有待顯示的訊息（來自路由守衛）
		const pendingAlert = this.$store.state.pendingAlert
		if (pendingAlert) {
			this.$alert(pendingAlert.message, pendingAlert.type)
			this.$store.commit('clearPendingAlert')
		}
	},
	beforeDestroy() {
		if (this.reconnectSyncTimer) {
			clearTimeout(this.reconnectSyncTimer)
			this.reconnectSyncTimer = null
		}
	},
	watch: {
		storeId(val, beforeVal) {
			if (val) {
				this.firstLoad = true
				this.menusReady = false
				this.initStore()
			}
		},
		async '$store.state.store.refreshMenu'(val) {
			if (val) {
				// 提前重置旗標，避免在等待期間阻擋新的刷新觸發
				this.$store.commit('store/SET_REFRESH_MENU', false)
				// 已有菜單時靜默刷新，避免顯示 loading 造成版面位移
				if (this.menusReady) {
					await this.reloadMenu({ silent: true })
				} else {
					this.firstLoad = true
					this.menusReady = false
					await this.reloadMenu()
				}
			}
		},
		isReadyToSetMenuDiscount(val, beforeVal) {
			if (val) {
				this.menuListSetDiscountPrice(this.source)
			}
		},
		// 重連成功：後端不會補推斷線期間的 MENU 推播，菜單需自行補刷
		reconnectSeq() {
			this.scheduleReconnectMenuRefresh()
		},
		// 比對 patch 只更新 price 等原始欄位，百分比特價是依價格蓋章的衍生值，
		// 需對 patch 落點（menus）重打；一般模式下 menus 即 source
		menuPatchSeq() {
			const menus = this.$store.state.store.menus
			if (menus && this.isReadyToSetMenuDiscount) {
				this.menuListSetDiscountPrice(menus)
			}
		},
		// 外部（購物車「重新選購」重拉菜單）以完整快照換掉整份 menus 時：
		// 先補折扣章（Detail 的讀取來源），再採納為本頁資料來源重建列表——
		// 否則 source 與 menus 分岔，後續 patch 與補章會打在不同陣列上
		'$store.state.store.menus'(val) {
			if (!val || val === this.source) return
			if (this.isReadyToSetMenuDiscount) {
				this.menuListSetDiscountPrice(val)
			}
			// 搜尋模式下列表顯示的是搜尋快照，只補章、不動列表
			if (!this.isAll) return
			this.source = val
			this.onTabChange(this.currentCategory)
		},
		currentCategory(val) {
			if (val !== undefined && val !== null) {
				sessionStorage.setItem('category', val)
			}
		},
	},
	beforeRouteLeave(to, from, next) {
		// 離開菜單頁時，保存當前的滾動位置
		this.saveCurrentPosition()
		next()
	},
	methods: {
		// 卡片折後標價：PERCENTAGE 折抵不取整，顯示時統一遠離零進位
		discountedItemPrice(item) {
			return ceilAwayFromZero(item.price - item.discountPrice)
		},
		// TAG: 處理取餐方式的選擇器點擊事件
		handlePickupMethodClick() {
			this.isPickupMethodShowing = true
		},
		handleCancelPickupMethod() {
			// 取消選擇取餐方式時的處理（目前無需特別處理）
		},
		handlePickUpConfirm(pickUpDraft) {
			this.$store.dispatch('user/confirmPickupMethod', pickUpDraft)
		},
		// 重連可每 1.5~3 秒觸發一次，不節流會對後端連續打全量 getMenu。
		// 合併到窗口尾端而非丟棄 —— 丟掉最後一次會讓菜單永遠停在舊狀態。
		scheduleReconnectMenuRefresh() {
			if (this.reconnectSyncTimer) {
				return
			}
			const wait = Math.max(
				0,
				RECONNECT_SYNC_INTERVAL - (Date.now() - this.lastReconnectSyncAt),
			)
			this.reconnectSyncTimer = setTimeout(() => {
				this.reconnectSyncTimer = null
				// 非靜默載入（首載 / 錯誤重試）在途即略過：該請求本身就會拿到最新菜單，
				// 再發並發的靜默請求只會經版本檢測把它作廢、殘留 isMenuLoading
				if (this.isMenuLoading) return
				this.lastReconnectSyncAt = Date.now()
				// 與 refreshMenu watch 同分支：已有菜單才靜默；首次載入失敗中
				//（menusReady=false）須走非靜默，否則 initStore 清掉 menuLoadError
				// 後三個反饋條件全空，錯誤面板連重試按鈕一起消失
				if (this.menusReady) {
					this.reloadMenu({ silent: true })
				} else {
					this.firstLoad = true
					this.reloadMenu()
				}
			}, wait)
		},
		async reloadMenu({ silent = false } = {}) {
			const success = await this.initStore(false, silent)
			// 只有「非靜默」載入成功才恢復捲動位置：yPosition 是上次離開頁面時存的，
			// 靜默背景刷新（推播 / 重連補刷）若也恢復，會把瀏覽中的畫面拉走
			if (success && !silent) {
				document.documentElement.style.scrollBehavior = 'auto'
				this.backToLastPagePosition()
				document.documentElement.style.scrollBehavior = 'smooth'
			}
		},
		toHtml(content) {
			// 基本的 HTML 轉義以防止 XSS 攻擊
			if (!content) return ''
			return content
				.replace(/&/g, '&amp;')
				.replace(/</g, '&lt;')
				.replace(/>/g, '&gt;')
				.replace(/"/g, '&quot;')
				.replace(/'/g, '&#x27;')
				.replace(/\n/g, '<br>')
		},
		openShopInfo() {
			this.isShopInfo = true
		},
		closeShopInfo() {
			this.isShopInfo = false
		},
		businessHoursText(businessHours) {
			const [openHours, openMinutes] = businessHours.openTime.split(':')
			const [closeHours, closeMinutes] = businessHours.closeTime.split(':')
			return (
				openHours + ':' + openMinutes + '–' + closeHours + ':' + closeMinutes
			)
		},
		onEditCart() {
			const validate = this.$refs.detailRef.handleEdit() !== false
			if (validate) {
				this.isDetailDialog = false
			}
		},
		onAddCart() {
			const validate = this.$refs.detailRef.onAddCart() !== false
			if (validate) {
				this.isDetailDialog = false
			}
		},
		searchTextInput(v) {},
		search() {
			if (this.$refs.searchInputRef) {
				this.$refs.searchInputRef.blur()
			}
			this.submittedKeyword = this.searchText
			this.initStore(true)
		},
		showDetailDialog(itemId) {
			this.detailId = itemId
			this.isEditDetail = true
			this.isDetailDialog = true
		},
		saveCurrentPosition() {
			// 保存分類選擇（已由 watcher 自動保存）
			// 保存分類 tab 的滾動位置
			if (this.$refs.categoryTabs) {
				const pickerBar = this.$refs.categoryTabs.$el
				sessionStorage.setItem('xPosition', String(pickerBar.scrollLeft))
			}
			// 保存頁面的滾動位置
			sessionStorage.setItem('yPosition', String(window.scrollY))
		},
		// 完整菜單請求：取號後緊接著捕捉版本（中間不得 await），
		// 回應再交給同一個快照 mutation，menus / 快取資訊 / 衝突蓋章一次寫完
		beginFullMenuRequest() {
			this.$store.commit('store/BUMP_FULL_MENU_REQUEST_SEQ')
			return captureFullMenuRequest({
				storeState: this.$store.state.store,
				socketState: this.$store.state.socket,
				storeId: this.storeId,
			})
		},
		// @returns {boolean} 本次回應是否被採用（false = 已有更新快照，呼叫端須改用當前 menus 收尾）
		applyFullMenuSnapshot(request, menuList) {
			this.$store.commit('store/SET_FULL_MENU_SNAPSHOT', {
				...request,
				menuList,
				fetchedAt: Date.now(),
			})
			return isFullMenuSnapshotApplied(this.$store.state.store, request)
		},
		isFullMenuSnapshotForCurrentStore() {
			const { storeId } = this.$store.state.store.fullMenuCacheMeta
			return storeId != null && String(storeId) === String(this.storeId)
		},
		// 同店家五分鐘內、期間無 MENU 推播 / 重連 / 新一輪購物車衝突 → 直接用快取
		canUseFullMenuCache() {
			const storeState = this.$store.state.store
			return isFullMenuCacheFresh({
				menus: storeState.menus,
				meta: storeState.fullMenuCacheMeta,
				storeId: this.storeId,
				menuChangeSeq: storeState.menuChangeSeq,
				reconnectSeq: this.$store.state.socket.reconnectSeq,
				cartConflictRevision: storeState.cartConflictRevision,
				fullMenuConflictRevision: storeState.fullMenuConflictRevision,
				now: Date.now(),
			})
		},
		findItemInMenuList(menuList, itemId) {
			for (const category of menuList || []) {
				const item = (category.itemList || []).find(
					candidate => String(candidate.itemId) === String(itemId),
				)
				if (item) return item
			}
			return null
		},
		async refreshFullMenuForDetail(itemId) {
			const request = this.beginFullMenuRequest()
			const result = (
				await this.$api.order.getMenu({
					storeId: this.storeId,
					keyword: '',
				})
			).data
			const menuList = result.menuList || []
			// Detail 建立時會立即讀取 menus；先在新陣列補齊顯示層折扣欄位，
			// 不依賴 Vue watcher 的下一輪排程才補章。此路徑不走 applyMenuList，
			// 蓋章責任留在這裡
			if (this.automaticDiscountListReady) {
				this.menuListSetDiscountPrice(menuList)
			}
			// 回應被更新的快照擋下時，只代表已有更新資料，不代表商品不存在：
			// 改從當前 menus 重查，找不到才回 null（由呼叫端提示下架）
			if (!this.applyFullMenuSnapshot(request, menuList)) {
				if (!this.isFullMenuSnapshotForCurrentStore()) {
					return null
				}
				return this.findItemInMenuList(this.$store.state.store.menus, itemId)
			}
			return this.findItemInMenuList(menuList, itemId)
		},
		async resolveSearchItemForDetail(item) {
			const menus = this.$store.state.store.menus
			const hasCachedItem = (menus || []).some(category =>
				(category.itemList || []).some(
					cachedItem => String(cachedItem.itemId) === String(item.itemId),
				),
			)
			if (!hasCachedItem) {
				return this.refreshFullMenuForDetail(item.itemId)
			}

			// 搜尋回應已是該商品的最新完整資料，只合併單品，
			// 不重打整份菜單，也不將其他商品誤標為已同步。
			this.$store.commit('store/MERGE_MENU_ITEM', item)
			return item
		},
		async goDetail(item) {
			if (!item.availableForSale || !this.canBuy) {
				return
			}

			let hasOptions = item.optionList && item.optionList.length > 0
			let hasUpgrades = item.upgradeList && item.upgradeList.length > 0
			let hasCombos = item.comboList && item.comboList.length > 0
			// 搜尋卡片一律以「畫面上這張卡」為準合併：即使它來自尚未落地或已失敗的
			// 那一輪搜尋，也只是把快取中同一 itemId 換成同構的舊資料，結帳前 compareCart
			// 仍會擋下；用版本守門去防它會讓請求失敗後整頁點不動，代價大於風險
			if (!this.isAll && (hasOptions || hasUpgrades || hasCombos)) {
				try {
					item = await this.resolveSearchItemForDetail(item)
				} catch (error) {
					$devLog('[Store] 搜尋餐點開啟詳情前刷新菜單失敗', error)
					this.$alert('菜單更新失敗，請稍後再試', 'danger')
					return
				}
				if (!item) {
					// 快照已換成別家店（切店）時查無商品是預期的，不可誤報下架
					if (this.isFullMenuSnapshotForCurrentStore()) {
						this.$alert('此商品已下架或暫時無法選購', 'danger')
					}
					return
				}
				if (!item.availableForSale) {
					return
				}
				hasOptions = item.optionList && item.optionList.length > 0
				hasUpgrades = item.upgradeList && item.upgradeList.length > 0
				hasCombos = item.comboList && item.comboList.length > 0
			}

			if (hasOptions || hasUpgrades || hasCombos) {
				if (this.isKiosk) {
					this.detailId = item.itemId
					this.isEditDetail = false
					this.isDetailDialog = true
					return
				}

				this.$router.push(`Detail/` + item.itemId)
			} else {
				const store = {
					count: 1,
					itemId: item.itemId,
					itemName: item.itemName,
					itemOptionDetailList: [],
					itemPrice: item.price,
					itemRemark: item.remark,
					comboList: item.comboList || [],
					automaticDiscountId: item.automaticDiscountId,
					automaticDiscountName: item.automaticDiscountName,
					automaticDiscountItemId: item.automaticDiscountItemId,
					discountPrice: item.discountPrice, // 折扣減去多少金額
					freeItem: false,
				}
				this.$alert(`${item.itemName} 已加入購物車`, 'success')
				this.$store.commit('user/LOGIN_AMOUNT_CART', {
					cartItems: [store],
					isResetCart: false,
				})
			}
		},
		backToLastPagePosition() {
			this.onTabChange(this.currentCategory)

			const mealItemYPosition = sessionStorage.getItem('yPosition')
			const categoryTabXPosition = sessionStorage.getItem('xPosition')

			this.$nextTick(() => {
				// 導航離開時元件已銷毀，排隊中的 nextTick 仍會執行到這裡
				if (!this.$refs.categoryTabs) return

				this.$refs.categoryTabs.setStyle()
				const pickerBar = this.$refs.categoryTabs.$el

				// 恢復分類 tab 的滾動位置
				if (categoryTabXPosition && !isNaN(parseInt(categoryTabXPosition))) {
					pickerBar.scrollLeft = parseInt(categoryTabXPosition)
				} else {
					// 如果沒有保存的位置，將選中的 tab 滾動到視野中央
					const activeTab = pickerBar.querySelector('.picker-tab.active')
					if (activeTab) {
						const tabLeft = activeTab.offsetLeft
						const tabWidth = activeTab.offsetWidth
						const barWidth = pickerBar.offsetWidth
						// 計算使 tab 居中的 scrollLeft 值
						const centerScrollLeft = tabLeft - barWidth / 2 + tabWidth / 2
						pickerBar.scrollLeft = Math.max(0, centerScrollLeft)
					}
				}
			})

			// 恢復頁面的滾動位置
			if (mealItemYPosition && !isNaN(parseInt(mealItemYPosition))) {
				window.scrollTo({
					top: parseInt(mealItemYPosition),
					behavior: 'auto',
				})
			}
		},
		// API 回應與快取命中共用的畫面重建；不含捲動還原（由呼叫端在 $nextTick 後處理）
		applyMenuList(menuList, { isSearch = false } = {}) {
			document.title = this.$storeManager.storeName || this.$route.meta.title

			this.isAll = this.submittedKeyword === ''
			this.source = menuList

			this.firstLoad = false
			this.menusReady = true
			this.isMenuLoading = false
			this.menuLoadError = null

			// 靜默重載、搜尋與快取命中都不會讓 isReadyToSetMenuDiscount 產生 false→true
			// 轉換（watch 不觸發），置換後的菜單物件需主動補打折扣欄位，
			// 否則「特價中」標籤與折扣價會消失
			if (this.automaticDiscountListReady) {
				this.menuListSetDiscountPrice(this.source)
			}

			let category = [{ id: '0', name: '全部' }]

			menuList.forEach(menu => {
				let visibleItems
				if (this.isKiosk) {
					visibleItems = menu.itemList
				} else {
					visibleItems = menu.itemList.filter(
						item => item.mobileStatus !== false,
					)
				}
				if (visibleItems.length > 0) {
					category.push({
						id: menu.categoryId,
						name: menu.categoryName,
					})
				}
			})

			this.category = category

			const isInside = this.category.some(
				item => item.id === this.currentCategory,
			)
			this.currentCategory = isInside ? this.currentCategory : '0'
			sessionStorage.setItem('category', this.currentCategory)
			this.onTabChange(isInside ? this.currentCategory : null)

			isSearch &&
				this.$nextTick(() => {
					this.$refs.categoryTabs?.setStyle()
				})
		},
		async initStore(isSearch, silent = false) {
			if (this.storeId === null) {
				console.warn('[Store] initStore 跳過：storeId 為 null')
				return false
			}

			// 遞增版本號，用於競態檢測
			const currentVersion = ++this.menuLoadVersion
			const isFullMenu = this.submittedKeyword === ''
			// 完整請求才需要版本快照；搜尋子集不寫入 canonical 快取
			const request = isFullMenu ? this.beginFullMenuRequest() : null
			this.menuLoadError = null
			// 靜默刷新時不顯示 loading，避免版面位移
			if (!silent) {
				this.isMenuLoading = true
			}

			try {
				const result = (
					await this.$api.order.getMenu({
						storeId: this.storeId,
						keyword: this.submittedKeyword,
					})
				).data

				// 競態檢測：版本已過期則放棄本次結果
				if (currentVersion !== this.menuLoadVersion) {
					return false
				}

				let menuList = result.menuList

				// menus 維持「完整菜單快取」語意（Detail 與購物車比對的查找來源）：
				// 搜尋結果是過濾子集，寫入會讓其他頁在子集中查無而誤報「商品已下架」
				if (isFullMenu && !this.applyFullMenuSnapshot(request, menuList)) {
					// 已有更新的完整快照落地（例如購物車重新選購的請求先回來）：
					// 不讓本次舊回應覆蓋，但畫面仍要收尾，改用當前快照重建
					menuList = this.$store.state.store.menus || menuList
				}

				this.applyMenuList(menuList, { isSearch })
				return true
			} catch (error) {
				// 競態檢測：過期的請求失敗不需要處理
				if (currentVersion !== this.menuLoadVersion) {
					return false
				}
				console.error('[Store] 載入菜單失敗:', error)
				this.isMenuLoading = false
				this.menuLoadError = error?.message || '載入菜單失敗'
				return false
			}
		},
		onTabChange(id) {
			if (id && id !== '0') {
				const category = this.source.find(item => item.categoryId === id)
				if (category) {
					this.rows = category.itemList
				} else {
					// 分類不存在（可能為 sessionStorage 殘留），回退到全部
					this.currentCategory = '0'
					this.rows = this.source.reduce((row, item) => {
						return row.concat(item.itemList)
					}, [])
				}
			} else {
				this.rows = this.source.reduce((row, item) => {
					return row.concat(item.itemList)
				}, [])
			}
		},
		handleItemPicLoadError(item) {
			this.$set(item, 'itemLogoUrl', null)
		},
		async onToOrder() {
			this.isToOrderLoading = true
			await this.$refs.compareCartConfirmRef
				.confirm()
				.finally(() => (this.isToOrderLoading = false))
		},
		onShowClearCartConfirm() {
			this.isShowClearCartConfirm = true
		},
		// 將menuList所有物件插入自動折扣id 、自動折扣名稱、折扣金額
		menuListSetDiscountPrice(list) {
			list.forEach(category => {
				category.itemList.forEach(item => {
					const find = this.findAutomaticDiscountByItemId(item.itemId)

					if (find?.automaticDiscount) {
						const { automaticDiscount, automaticDiscountItem } = find
						// vue 狀態物件中插入新屬性，使用$set才能讓畫面響應渲染
						this.$set(item, 'automaticDiscountId', automaticDiscount.id)
						this.$set(item, 'automaticDiscountName', automaticDiscount.name)
						this.$set(item, 'automaticDiscountItemId', automaticDiscountItem.id)
						if (automaticDiscount.discountType === 'AMOUNT') {
							this.$set(item, 'discountPrice', automaticDiscount.discountAmount)
						} else if (automaticDiscount.discountType === 'PERCENTAGE') {
							// 這裡會保留小數 提供數量複數時計算，注意要在商品價格呈現時取整
							// 並且不能使用折扣後金額，否則折數折扣數量複數時金額會出現取整誤差
							this.$set(
								item,
								'discountPrice',
								item.price -
									item.price *
										(0.01 * automaticDiscount.discountPercentage).toFixed(2),
							)
						}
					} else {
						this.$set(item, 'automaticDiscountId', null)
						this.$set(item, 'automaticDiscountName', null)
						this.$set(item, 'automaticDiscountItemId', null)
						this.$set(item, 'discountPrice', null)
					}
				})
			})
		},
		// 以itemId取得自動折扣
		findAutomaticDiscountByItemId(itemId) {
			let find = { automaticDiscount: null, automaticDiscountItem: null }
			find.automaticDiscount = this.itemAutomaticDiscountList.find(
				automaticDiscount => {
					return automaticDiscount.automaticDiscountItemList.find(
						automaticDiscountItem => {
							if (automaticDiscountItem.itemId === itemId) {
								find.automaticDiscountItem = automaticDiscountItem
								return true
							}
							return false
						},
					)
				},
			)

			return find
		},
		formatFixedRest(restDays) {
			if (!restDays || restDays.length === 0) {
				return '無'
			}
			// 多加一層filter過濾掉無效值(日期格式不符)
			const validDays = restDays
				.map(day => this.week[day])
				.filter(dayLabel => Boolean(dayLabel))
			if (validDays.length === 0) {
				return '無'
			}
			return validDays.join('、')
		},

		formatUnfixedRest(restDates) {
			if (!restDates || restDates.length === 0) {
				return '無'
			}
			// 多加一層filter過濾掉無效值(日期格式不符)
			const dates = restDates
				.filter(date => typeof date === 'string' && date.split('-').length >= 3)
				.map(date => date.split('-')[2] + '號')
				.filter(dateLabel => Boolean(dateLabel))
				.join('、')
			if (!dates) {
				return '無'
			}
			return '本月 ' + dates
		},

		formatMixedRest(restDays, restDates) {
			const daysPart = this.formatFixedRest(restDays)
			const datesPart = this.formatUnfixedRest(restDates)

			if (daysPart === '無' && datesPart === '無') {
				return '無'
			}

			if (daysPart && daysPart !== '無' && datesPart === '無') {
				return daysPart
			}

			if (daysPart === '無' && datesPart && datesPart !== '無') {
				return datesPart
			}

			return daysPart + '\n及 ' + datesPart
		},
	},
}
</script>

<style lang="sass" scoped>
@import '@/utils/style.sass'
.pickUp-method-wrapper
	position: relative
	padding: 0% 5%
	margin-bottom: 10px
	color: #294B70
	.pickUp-method-displayer
		position: relative
		border: 2px solid #294B70
		font-weight: bold
		padding: 15px
		border-radius: 8px
		text-align: center
		.icon-wrapper
			+size(20px)
			position: absolute
			right: 0
			top: 50%
			transform: translate(-50%, -50%)
		&.--method-exist
			text-align: left

.center-page-minus
	padding: 0

.category-title
	font-size: 20px
	font-weight: bolder
	margin-top: 10px

.picker-bar
	position: sticky
	top: 50px
	left: 0
	z-index: 5
	background: #fff

	&.--kiosk
		margin-right: auto
		width: 100%

.product-container
	display: flex
	align-items: flex-start

	.items
		flex: 1
		padding-bottom: 12px
		margin-right: 350px

		.category-title
			padding: 8px 17.5px 0

		.product
			&-grid
				width: 100%
				margin-bottom: 25px
				padding: 0 17.5px
				@media screen and (min-width: 700px)
					display: flex
					flex-wrap: wrap

			&-item
				display: flex
				border-bottom: 1px solid #D8D8D8
				padding: 15px 0
				position: relative

				&.no-content
					.product-info
						min-height: 50px

				.sold-out-overlay
					position: absolute
					z-index: 3
					top: 0
					right: 0
					bottom: 0
					left: 0
					background-color: rgba(255, 255, 255, 0.5) !important

				@media screen and (min-width: 700px)
					width: 50%
					&:nth-child(2n + 1)
						padding-right: 15px

			&-img
				width: 80px
				height: 80px
				position: relative
				border-radius: 15px
				overflow: hidden
				background: url(../../assets/load-img1.png)
				background-size: cover
				background-position: center center

				img
					width: 80px
					height: 80px
					position: absolute
					left: 0
					top: 0
					object-fit: cover
					display: flex
					align-items: center

				.sold-out-text
					position: absolute
					z-index: 3
					display: flex
					justify-content: center
					background-color: rgba(128, 128, 128)
					white-space: nowrap
					top: 50%
					left: 50%
					transform: translate(-50%, -50%)
					padding: 5px 20px
					color: white
					border-radius: 15px
					font-size: calc(8px + 0.625rem)

			&-info
				min-height: 80px
				flex: 1
				display: flex
				justify-content: space-between
				flex-direction: column
				flex-wrap: wrap
				margin: 0 12px

			&-status
				+fc
				margin-left: 5px

				> *:not(:last-child)
					margin-right: 8px

				&-discount-tag
					border-radius: 4px
					background: rgba(243, 114, 1, .1)
					color: #f37201
					font-weight: 700
					font-size: 1rem
					padding: 4px 8px
					margin-left: 4px

			//名稱
			&-name
				display: flex
				align-items: center
				font-size: 16px
				font-weight: bold
			//內容
			&-content
				min-height: 32px
				line-height: 18px
				margin-bottom: 4px
				color: #8E8E8E
				font-size: 14px

			&-price-area
				font-size: 15px
				display: flex
				flex-direction: row

				&-original-price
					text-decoration: line-through

				&-discount-price
					margin-left: 10px
					color: #f37201

			&-plus
				display: flex
				justify-content: center
				align-items: center
				position: relative
				width: 80px
				height: 80px

				img
					width: 27.5px
					height: 27.5px

				.sold-out-text
					z-index: 3
					white-space: nowrap
					top: 0
					right: 0
					bottom: 0
					left: 0
					background-color: rgba(128, 128, 128)
					color: white
					border-radius: 15px
					padding: 5px 20px
					font-size: calc(8px + 0.625rem)

			&-empty
				min-height: 100px
				+fc
				color: #8E8E8E
				font-style: italic

	.cart-panel
		width: 350px
		height: calc(100% - 50px)
		position: fixed
		top: 50px
		right: 0
		z-index: 2
		background: #f9f9f9
		display: flex
		flex-direction: column

		&_title
			font-size: 20px
			font-weight: bolder
			padding: 12px 15px

		&_grid
			flex: 1
			overflow: auto
			-webkit-overflow-scrolling: touch

		&_welcome
			flex: 1
			font-size: 18px
			padding: 12px 15px
			color: rgba(#000, .5)

		&-order-discount
			position: relative
			padding: 20px 15px 15px 15px

			&-use
				color: #f37201
				display: flex
				justify-content: space-between
				font-family: 'Arial Negreta', 'Arial Normal', 'Arial', sans-serif

			&-next
				margin-top: 15px
				font-size: 14px
				font-weight: 700
				font-family: 'Arial Negreta', 'Arial Normal', 'Arial', sans-serif
				color: #D9001B

		&_remark
			display: block
			width: calc(100% - 30px)
			margin: 0 auto 12px

			&::v-deep
				textarea
					border-radius: 10px
					border: 1px solid #cecece
					padding: 10px
					height: 80px

		&_btns
			display: flex
			padding: 0 15px 12px

			.btn
				width: 80px

				&.send
					margin-left: 8px
					flex: 1
					align-items: center
					justify-content: center
					margin-right: 0
					padding: 0 12px

					.btn_text
						margin: 0 auto

.search
	width: calc(100% - 35px)
	display: block
	margin: 20px auto

	&.--kiosk
		width: 250px
		position: fixed
		right: 64px
		top: 5px
		margin: 0
		z-index: 1000

.not-open
	background: rgba(#294B70, .4)
	border-radius: 4px
	padding: 8px 12px
	line-height: 1.5
	width: calc(100% - 35px)
	margin: 0 auto
</style>

<style lang="sass">
.detail-dialog--kiosk
	.dialog-body
		padding: 0

	.kiosk-dialog-footer-wrap
		position: sticky
		bottom: 0
		background: #fff
		border-top: 1px solid #D8D8D8
		width: 100%
		height: 56px
		padding-top: 8px

		.btn
			width: calc(100% - 40px)
			margin: 0 auto
</style>
